import React from 'react';
import { motion } from 'framer-motion';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from '../hooks/useTranslation';
import '../styles/Footer.css';

const Footer = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer id="contact" className="footer">
      <div className="footer-content">

        <div className="footer-section connect-section">
          <h3>{t('footer.contact')}</h3>
          <div className="social-links">
            <motion.a
              href="https://linkedin.com/in/jonathanllamas"
              target="_blank"
              rel="noopener noreferrer"
              whileHover={{ y: -5, color: '#ffcc00' }}
              transition={{ duration: 0.2 }}
              aria-label="LinkedIn"
            >
              <FontAwesomeIcon icon={faLinkedin} />
            </motion.a>


            <motion.a
              href="mailto:jonathan@llamas.ovh"
              whileHover={{ y: -5, color: '#ffcc00' }}
              transition={{ duration: 0.2 }}
              aria-label="Email"
            >
              <FontAwesomeIcon icon={faEnvelope} />
            </motion.a>
          </div>
        </div>

      </div>
      <div className="footer-bottom">
        <div className="gear-decoration gear-left"></div>
        <p>&copy; {currentYear} LLAMAS Jonathan - Maintenance Portfolio. {t('footer.rights')}</p>
        <div className="gear-decoration gear-right"></div>
      </div>
    </footer>
  );
};

export default Footer;